export default __webpack_public_path__ + "static/media/android.633636ed.svg";